export default function authHeader() {
    const user = JSON.parse(localStorage.getItem('user'))[0];
  
    if (user && user.access_token) {
      return { Authorization: "Bearer " + user.refresh_token };
    } else {
      return {};
    }
  }